<template>
  <d-modal
    class="crm-new-popup"
    v-if="showModal"
    @close="closeModal"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header class="calendar-popup-header">
      <d-modal-title>
        <h3 class="page-title text-nowrap">
          Dodaj ważenie
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-container
        fluid
        class="px-4">
        <!-- Page Header -->
        <div class="form-group">
          <label for="file">
            Ważenie:
          </label>
          <validation-provider
            :rules="'required'"
            :name="'scan'"
            v-slot="{ errors }">
            <file-input
              class="form-group"
              :onChange="setImage"
              :id="'scan'" />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="popup-box-buttons">
          <d-button
            :disabled="!file"
            theme="success"
            class="text-nowrap w-100"
            @click.prevent="submitForm">
            Potwierdź
          </d-button>
          <d-button
            style="width: 100%"
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="closeModal">
            Anuluj
          </d-button>
        </div>
      </d-container>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from '@/utils/FormUtils';

export default {
  name: 'order-file',
  data () {
    return {
      file: ''
    };
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    closeModal: {
      type: Function,
      required: true
    },
    refresh: {
      type: Function,
      required: true
    }
  },
  methods: {
    setImage (event) {
      this.file = event.target.files[0];
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {};
      if (this.file) {
        formDataToSend.file = this.file;
        imageFields = ['file'];
      }
      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: '/orders/import-excel',
        formData: formDataToSend,
        successTitle: 'Zapisano dokument',
        successText: 'Wybrany dokument został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje dokumentu nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.refresh();
        }
      }, imageFields);
    },
  }
};
</script>

<style lang="scss">
.modal-body {
  .popup-box-buttons {
    display: flex;
    margin-top: 1rem;
    border-top: 1px solid #FBFBFB;
    padding-top: 2rem;
    button {
      width: 100%;
    }
  }
  .popupForm .modal-dialog {
    margin-top: 5rem;
  }
}
</style>
